module.exports = __webpack_public_path__ + "img/La.fa9ddf96.png";